import React from "react";
import PUC_Header from "./PUC_Header";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
const WrapHeader = ({ children }) => {
  return (
    <Box>
      <CssBaseline />

      <PUC_Header />
      <Box
        py={8}
        sx={{
          width: "100%"
        }}>
        {children}
      </Box>
    </Box>
  );
};
export default WrapHeader;
